import { tgbEventBus } from './tbgEventBus';
import Market, { g_callbackMap, installedListCache, ICpuInfo, IMemoryInfo, INetInfo } from './Market';

export interface IResolveEnterUrlParam {
  url: string;
}

export interface ISetApkMigrateMarkParam {
  pkgName: string;
  isMigrate: boolean;
}

// here we handle c++ call js function
const tgbWebCallSink = {
  ResolveEnterUrl(param: IResolveEnterUrlParam) {
    tgbEventBus.$emit('webcall.ResolveEnterUrl', param);
  },

  SetApkMigrateMark(param: ISetApkMigrateMarkParam) {
    tgbEventBus.$emit('webcall.SetApkMigrateMark', param);
  },

  OpenHelp(param) {
    tgbEventBus.$emit('webcall.OpenHelp', param);
  },

  JumpGift(param) {
    tgbEventBus.$emit('webcall.JumpGift', param);
  },
  JumpVipGift(param) {
    tgbEventBus.$emit('webcall.JumpVipGift', param);
  },

  OpenSettingCenter(param) {
    tgbEventBus.$emit('webcall.OpenSettingCenter', param);
  },
  /**
   * 离线页更新成功通知
   * @param param {"result":true}
   */
  CompleteLocalPageUpdate(param) {
    tgbEventBus.$emit('webcall.CompleteLocalPageUpdate', param);
  },
};

export interface IUserLoginLogoutParam {
  openId: string;
  platform: string;
  callSource: number;
}

export interface IUserLogoutParam {
  openId: string;
  platform: string;
  callSource: number;
}

export interface IPkgInstallProgressParam {
  pkgName: string;
  gameId: string;
  area: string;
  download: boolean;
  percent: number;
  downloadSpeed: number;
  downloadedSize: string;
  totalSize: string;
}

export interface IEngineProgressParam {
  status: number;
  percent: number;
}

export interface IGLESUpateProgressParam {
  pkgName: string;
  succeed: boolean;
  percent: number;
}

export interface IPkgStateChangeParam {
  pkgName: string;
  gameId: string;
  area: string;
  state: number;
  error: number;
  source?: string;
}

export interface ITGVoiceCloudSwitchParam {
  show: boolean;
}

export interface IAppRunningParam {
  pkgName: string;
  running: boolean;
}

export interface IShowLoginWindowForChinaParam {
  source: number;
}

export interface IPkgAutoInstallInf {
  pkgName: string;
  pkgArea: string;
  supplyid: number;
  isPreDownloadItem: boolean;
  overTime: number;
  sourceType: number;
}

export interface IPkgLocalInstallInf {
  pkgName: string;
  base64Param: string;
  displayName: string;
  version: string;
  size: string;
  localApkPath: string;
}

export interface IScreenSaverStateInfo {
  screenSaverRunning: boolean;
}

export interface ICriticalHardDiskStateInfo {
  isfull: boolean;
  sfFreeSpace: number;
}

export interface IEumlatorStateInfo {
  hasEumlator: boolean;
}

export interface IMarketStateInfo {
  hasMarket: boolean;
}

// here we handle c++ event post to js for Market module
const MarketEventSink = {
  PrefetchData(param: {code: number; data: any; msg: string}) {
    tgbEventBus.$emit('Market.PrefetchData', param);
  },
  UserLogin(param: IUserLoginLogoutParam) {
    tgbEventBus.$emit('Market.UserLogin', param);
  },

  UserLogout(param: IUserLoginLogoutParam) {
    tgbEventBus.$emit('Market.UserLogout', param);
  },

  PkgAutoInstallInf(param: IPkgAutoInstallInf) {
    /** 通知自动下载 */
    tgbEventBus.$emit('Market.PkgAutoInstallInf', param);
  },

  PkgLocalInstallInf(param: IPkgLocalInstallInf) {
    /** 通知本地安装 */
    tgbEventBus.$emit('Market.PkgLocalInstallInf', param);
  },

  PkgInstallProgress(param: IPkgInstallProgressParam) {
    // 修改已装列表进度
    if (installedListCache) {
      try {
        const lowerPkgName = param.pkgName && param.pkgName.toLowerCase();
        const installedGame = installedListCache.find((game) => (
          game.game_id && game.game_id.toLowerCase() === lowerPkgName
        ));

        installedGame.percent = param.percent;
      } catch (error) {
        console.log(error);
      }
    }

    tgbEventBus.$emit('Market.PkgInstallProgress', param);
  },

  EngineProgress(param: IEngineProgressParam) {
    tgbEventBus.$emit('Market.EngineProgress', param);
  },

  // 兼听主窗口启动
  ShowMainWIndow(param) {
    tgbEventBus.$emit('Market.ShowMainWIndow', param);
  },

  GoogleAdEngineInstallFinish(param: { pkgName: string }) {
    tgbEventBus.$emit('Market.GoogleAdEngineInstallFinish', param);
  },

  GLESUpateProgress(param: IGLESUpateProgressParam) {
    tgbEventBus.$emit('Market.GLESUpateProgress', param);
  },

  async PkgStateChange(param: IPkgStateChangeParam) {
    // 修改缓存的安装列表状态
    if (installedListCache) {
      try {
        const lowerPkgName = param.pkgName && param.pkgName.toLowerCase();
        const newState = param.state;
        if (
          // 开始安装
          ((newState === Market.installState.UpdateConfig
            || newState === Market.installState.BeginDownload)
            && installedListCache.every((game) => (
              game.game_id && game.game_id.toLowerCase() !== lowerPkgName
            )))
          // 卸载完成
          || (newState === Market.installState.EndUninstall
            && installedListCache.some((game) => game.game_id
              && game.game_id.toLowerCase() === lowerPkgName))
        ) {
          await Market.GetInstalledList(true);
        }

        // 安装状态到游戏列表状态
        const stateMap = {
          0: 1,
          1: 3,
          2: 4,
          3: 6,
          4: 6,
          6: 2,
          7: 1,
          10: 1,
          14: 1,
          15: 6,
        };
        installedListCache.forEach((game) => {
          if (game.game_id && game.game_id.toLowerCase() === lowerPkgName) {
            game.state = stateMap[newState] || 6;
          }
        });
      } catch (error) {
        console.log(error);
      }
    }

    tgbEventBus.$emit('Market.PkgStateChange', param);
  },

  RedDotUpdate(param) {
    tgbEventBus.$emit('Market.RedDotUpdate', param);
  },
  TGVoiceCloudSwitch(param: ITGVoiceCloudSwitchParam) {
    tgbEventBus.$emit('Market.TGVoiceCloudSwitch', param);
  },
  StartScreenAd(param) {
    tgbEventBus.$emit('Market.StartScreenAd', param);
  },

  // onestore token 过期通知
  OneStoreTokenExpired() {
    tgbEventBus.$emit('Market.OneStoreTokenExpired');
  },

  // onestore 终端通知市场打开游戏详情
  OneStoreProductDetail(param) {
    tgbEventBus.$emit('Market.OneStoreProductDetail', param);
  },

  FinishPreDownloadAPK() {
    tgbEventBus.$emit('Market.FinishPreDownloadAPK');
  },
  ShowFeedBackWindow(param) {
    tgbEventBus.$emit('Market.ShowFeedBackWindow', param);
  },
  MarketingNotifyWnd(param) {
    tgbEventBus.$emit('Market.MarketingNotifyWnd', param);
  },
  NetBoosterSwitch(param) {
    tgbEventBus.$emit('Market.NetBoosterSwitch', param);
  },
  AppRunning(param: IAppRunningParam) {
    tgbEventBus.$emit('Market.AppRunning', param);
  },
  ShowLoginWindowForChina(param: IShowLoginWindowForChinaParam) {
    tgbEventBus.$emit('Market.ShowLoginWindowForChina', param);
  },
  // 客户端更新进度回传
  UpdateProgress(param) {
    tgbEventBus.$emit('Market.UpdateProgress', param);
  },
  // 客户端更新状态回传
  UpdateState(param) {
    tgbEventBus.$emit('Market.UpdateState', param);
  },
  // 通用WebSocket事件
  WebSocketMessage(param) {
    tgbEventBus.$emit('Market.WebSocketMessage', param);
  },
};

export interface IMessageParam {
  senderId: number;
  senderName: string;
  message: string;
}

// here we handle c++ event post to js for Ipc module
const IpcEventSink = {
  SendMessage(param: IMessageParam) {
    tgbEventBus.$emit('Ipc.SendMessage', param);
  },
  BroadCastMessage(param: IMessageParam) {
    tgbEventBus.$emit('Ipc.BroadCastMessage', param);
  },
};

export interface IWindowShowParam {
  visible: boolean;
}

export interface IWindowWantToCloseParam {
  browserId: number;
  name: string;
  openerId: number;
  handle: number;
}

const WindowEventSink = {
  Show(param: IWindowShowParam) {
    tgbEventBus.$emit('Window.Show', param);
  },
  WindowStateChange(param) {
    tgbEventBus.$emit('Window.WindowStateChange', param);
  },
  NcLButtonDown(param) {
    tgbEventBus.$emit('Window.NcLButtonDown', param);
  },
  WindowWantToClose(param: IWindowWantToCloseParam) {
    tgbEventBus.$emit('Window.WindowWantToClose', param);
  },
};

const GameMan19 = {
  GameInstallListUpdate(param) {
    tgbEventBus.$emit('GameMan19.GameInstallListUpdate', param);
  },
  GameInstallItemUpdate(param) {
    tgbEventBus.$emit('GameMan19.GameInstallItemUpdate', param);
  },
};

export interface IFullScreenStateChangeParam {
  fullScreen: boolean;
}

const SysMonEventSink = {
  /* 全屏状态变化
     SysMon.FullScreenStateChange( {fullScreen : boolean} )
  */
  FullScreenStateChange(param: IFullScreenStateChangeParam) {
    tgbEventBus.$emit('SysMon.FullScreenStateChange', param);
  },
  /* cpu达到设置的阈值
     SysMon.CriticalCpuChange（{cores: number, usage : number}）
  */
  CriticalCpuChange(param: ICpuInfo) {
    tgbEventBus.$emit('SysMon.CriticalCpuChange', param);
  },
  /* 内存占比达到阈值
     SysMon.CriticalMemoryChange({ sizeInMB : number, usage: number })
  */
  CriticalMemoryChange(param: IMemoryInfo) {
    tgbEventBus.$emit('SysMon.CriticalMemoryChange', param);
  },
  /* 网络下行达到阈值
     SysMon.CriticalNetworkChange({
       bandwithInMbps : number,
       netInLoadInMbps : number,
       netOutLoadInMbps : number
     })
  */
  CriticalNetworkChange(param: INetInfo) {
    tgbEventBus.$emit('SysMon.CriticalNetworkChange', param);
  },
  /* 开启屏保
        struct SysScreenState
    {
        bool screenSaverRunning = false;//使用进入屏保状态
    };
  */
  ScreenSaverStateChange(param: IScreenSaverStateInfo) {
    tgbEventBus.$emit('SysMon.ScreenSaverStateChange', param);
  },
  /* 到达额定硬盘
    struct SysHardDiskState
    {
        bool isfull = false;//是否已满 如果是  true 的话提示磁盘满了
        std::uint64_t sfFreeSpace = 0;//剩余空间
    };
  */
  CriticalHardDiskStateChange(param: ICriticalHardDiskStateInfo) {
    tgbEventBus.$emit('SysMon.CriticalHardDiskStateChange', param);
  },
  EumlatorStateChange(param: IEumlatorStateInfo) {
    tgbEventBus.$emit('SysMon.EumlatorStateChange', param);
  },
  MarketStateChange(param: IMarketStateInfo) {
    tgbEventBus.$emit('SysMon.MarketStateChange', param);
  },
};

window.__tbsRecieveNativeResult__ = function __tbsRecieveNativeResult__(nativeResult) {
  const { extendCallId } = nativeResult;
  if (g_callbackMap[extendCallId]) {
    g_callbackMap[extendCallId](nativeResult);
    delete g_callbackMap[extendCallId];
  }
};

/**
 * global function to recieve native event
 */
function __tbsRecieveNativeEvent__(event: string, data: string) {
  const [mod, api] = event.split('.');
  if (!mod) {
    return;
  }

  if (!sessionStorage.hideNativeEvent) {
    console.log('__tbsRecieveNativeEvent__', event, data);
  }

  try {
    const param = JSON.parse(data);
    if (mod === 'webcall') {
      tgbWebCallSink[api](param);
    } else {
      // notify event
      tgbEventSink[mod]?.[api]?.(param);
    }
  } catch (error) {
    console.error(error);
  }

  Array.prototype.slice
    .call(document.querySelectorAll('iframe'))
    .forEach((v) => {
      if (!v.contentWindow) {
        return;
      }

      v.contentWindow.postMessage(
        {
          type: '__tbsRecieveNativeEvent__',
          event,
          data,
        },
        '*',
      );
    });
}

// global function to recieve common c++ event callback
window.__tbsRecieveNativeEvent__ = __tbsRecieveNativeEvent__;

window.addEventListener('message', (e) => {
  if (/\.(qq|gameloop)\.com$/.test(e.origin)) { // 限制qq域
    const data = e.data || {};
    if (data.type === '__tbsRecieveNativeResult__') { // 父页面回调给只页面
      window.__tbsRecieveNativeResult__(data);
    } else if (data.type === 'marketApi') { // 处理子页面请求
      Market[data.api](...data.params).then((res) => {
        if (!e.source) {
          return;
        }

        if (!(e.source instanceof MessagePort) && !(e.source instanceof ServiceWorker)) {
          e.source.postMessage({
            type: '__tbsRecieveNativeResult__',
            succeed: true,
            result: res,
            extendCallId: data.id,
          }, '*');
        }
      }, (err) => {
        if (!e.source) {
          return;
        }

        if (!(e.source instanceof MessagePort) && !(e.source instanceof ServiceWorker)) {
          e.source.postMessage({
            type: '__tbsRecieveNativeResult__',
            succeed: false,
            error: err,
            extendCallId: data.id,
          }, '*');
        }
      });
    } else if (data.type === '__tbsRecieveNativeEvent__') { // 收到父页面通知
      __tbsRecieveNativeEvent__(data.event, data.data);
    }
  }
});

// 屏蔽拖拽问题
window.addEventListener('dragstart', (e) => {
  e.preventDefault(); e.stopPropagation();
}, false);

window.addEventListener('drag', (e) => {
  e.preventDefault(); e.stopPropagation();
}, false);

window.addEventListener('dragover', (e) => {
  e.preventDefault(); e.stopPropagation();
}, false);

window.addEventListener('drop', (e) => {
  e.preventDefault(); e.stopPropagation();
}, false);

export const tgbEventSink = {
  Market: MarketEventSink,
  Ipc: IpcEventSink,
  Window: WindowEventSink,
  GameMan19,
  SysMon: SysMonEventSink,
};
